import {StateToken} from '@ngxs/store';

export type AcTableStateModels = any;
export const AC_TABLE_STATE_TOKEN = new StateToken<AcTableStateModels>('tableState');
